import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';


export function getUserPreferences() { 
     return function (dispatch) {
         return APIutil.getDataAPI(url.user_preferences).then(response => {
           // dispatch(global_error_handling(response));  
            var data = null;
            (response.culture !== undefined) ?   data = response.culture  : data = 'en-US' ;
            localStorage.setItem('Culture', data);
			dispatch(actionToStoreSuccess(response,types.GET_USER_PREFERENCES_SUCCESSFULL));
              import('../Resources/TenantServices/TenantServices.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
              import('../Resources/SystemAdmin/SystemAdmin.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_SYSTEM_ADMIN_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
              import('../Resources/DMResources/DMResources.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_DMRESOURCES_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
              import('../Resources/Common/Common.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_COMMON_RESOURCE)); });
              import('../Resources/WorkOrders/WorkOrders.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_WORKORDERS_RESOURCE)); });  
              import('../Resources/DataVisualization/DataVisualization.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData, types.GET_DATAVIS_LABELS_BASED_ON_CULTURE_SUCESSFULL)); });
              import('../Resources/ReportManagement/ReportManagement.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData, types.GET_REPORTMGMT_LABELS_BASED_ON_CULTURE_SUCESSFULL)); });
              import('../Resources/Status/Status.'+ data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData, types.SET_STATUS_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
         }).catch(error => {
            dispatch(global_error_handling(false));
             throw error;
         })
     }
 }

 export function getUserPreferencesFromEquipmentSummary() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.user_preferences).then(response => {
          // dispatch(global_error_handling(response));  
           var data = null;
           (response.culture !== undefined) ?   data = response.culture  : data = 'en-US' ;
           localStorage.setItem('Culture', data);
           dispatch(actionToStoreSuccess(response,types.GET_USER_PREFERENCES_SUCCESSFULL));
             import('../../src/Resources/TenantServices/TenantServices.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
             import('../../src/Resources/SystemAdmin/SystemAdmin.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_SYSTEM_ADMIN_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
             import('../../src/Resources/DMResources/DMResources.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_DMRESOURCES_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
             import('../../src/Resources/Common/Common.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_COMMON_RESOURCE)); });
             import('../../src/Resources/WorkOrders/WorkOrders.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_WORKORDERS_RESOURCE)); });  
             import('../../src/Resources/DataVisualization/DataVisualization.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData, types.GET_DATAVIS_LABELS_BASED_ON_CULTURE_SUCESSFULL)); });
             import('../../src/Resources/ReportManagement/ReportManagement.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData, types.GET_REPORTMGMT_LABELS_BASED_ON_CULTURE_SUCESSFULL)); });
             import('../../src/Resources/Status/Status.'+ data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData, types.SET_STATUS_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
        }).catch(error => {
           dispatch(global_error_handling(false));
            throw error;
        })
    }
}

 export function UpdateUserPreferences(ID,Data){
     return function(dispatch){
         return APIutil.editDataAPI(url.edit_user_preferences+ID+"/preferences", Data).then(response =>{
            dispatch(getUserPreferences())
         }).catch(error => {
            dispatch(global_error_handling(false));
             throw error;
         })
     }
 }



export function getCommonResources_Action() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.user_preferences).then(response => {
           dispatch(global_error_handling(response));  
           var data = null;
           (response.culture !== undefined) ?   data = response.culture  : data = 'en-US' ;
           dispatch(actionToStoreSuccess(response,types.GET_USER_PREFERENCES_SUCCESSFULL));
                import('../Resources/Common/Common.'+data) 
                   .then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_COMMON_RESOURCE)); });

        }).catch(error => {
           dispatch(global_error_handling(false));
            throw error;
        })
    } 
}

export function getAllResources() { 
    return function (dispatch) {
        var data = localStorage.getItem('Culture');
        if (!data) {
            dispatch(getUserPreferences());
        } else {
            import('../Resources/TenantServices/TenantServices.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
            import('../Resources/SystemAdmin/SystemAdmin.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_SYSTEM_ADMIN_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
            import('../Resources/DMResources/DMResources.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_DMRESOURCES_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
            import('../Resources/Common/Common.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_COMMON_RESOURCE)); }); 
            import('../Resources/WorkOrders/WorkOrders.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData,types.GET_WORKORDERS_RESOURCE)); }); 
            import('../Resources/ReportManagement/ReportManagement.'+data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData, types.GET_REPORTMGMT_LABELS_BASED_ON_CULTURE_SUCESSFULL)); });
            import('../Resources/Status/Status.'+ data).then((resourceData) => { dispatch(actionToStoreSuccess(resourceData.resourceData, types.SET_STATUS_LABELS_BASED_ON_CULTURE_SUCCESSFULL)); });
        }
    }
}


export function getUserDetailsAfterLogin() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.user_details_after_login).then(response => {
           dispatch(global_error_handling(response));  
           dispatch(actionToStoreSuccess(response,types.GET_USER_INFO));
        }).catch(error => {
           dispatch(global_error_handling(false));
            throw error;
        })
    }
}


export function actionToStoreSuccess(data,actionType){
    return{
        type: actionType,
        getResponse: data,
    }
}

